import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TaskPauseReason } from 'app/shared/enums/task-pause-reasons';
import { TaskStatus } from 'app/shared/enums/task-status.enum';
import { TaskDetailsResponse } from 'app/shared/types';

@Component({
    selector: 'app-task-status-chip',
    imports: [CommonModule, TranslateModule, MatChipsModule, MatIcon],
    templateUrl: './task-status-chip.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskStatusChipComponent implements ICellRendererAngularComp {
  public text = '';
  public classes = '';
  public isPaused = false;
  public taskDetails!: TaskDetailsResponse;
  public canBackOfficeUnPause = false;

  public agInit(params: ICellRendererParams): void {
    this.refreshData(params);
  }

  public refresh(params: ICellRendererParams): boolean {
    this.refreshData(params);
    return true;
  }

  private refreshData(params: ICellRendererParams): void {
    this.text = params.valueFormatted ?? params.value ?? '';

    this.isPaused = params.value === TaskStatus.PAUSED;
    this.taskDetails = params.data;
    this.canBackOfficeUnPause =
      params.value === TaskStatus.PAUSED &&
      (params.data?.pauseReasonCode === TaskPauseReason.GladHandle ||
        params.data?.pauseReasonCode === TaskPauseReason.RedLight);

    this.classes = params?.context.classes || '';
  }
}
